module.exports = __webpack_public_path__ + "static/media/13-video2.878501fc.png";